import React, { useState, useEffect } from 'react';
import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import env from '../../../environment.js';
import { subscribe, unsubscribe } from '../../../components/events';
import EntregasXProductorFirma from './entregas-x-productor-firma.js';
import EntregasXProductorInfo from './entregas-x-productor-info.js';
import EntregasXProductorBuscador from './entregas-x-productor-buscador.js';
import './entregas-x-productor.css';
import ExampleCustomInput from '../../../components/modal/input.jsx';
import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { es } from 'date-fns/locale';
import { yupResolver } from '@hookform/resolvers/yup';
import FormInputMaterialTest from '../../../nuup/componentes/Forms/FormInputMaterialTest.jsx';
import { getValidationSchema } from './entregas-x-productor.schema.js';
import FormSelectMaterial from '../../../nuup/componentes/Forms/FormSelectMaterial.jsx';
import { useParams } from 'react-router-dom';
import Select, { components } from 'react-select';
import { v4 as uuidv4 } from 'uuid';
import formatMoneyNumber from '../../../utils/formatNumber.js';
import {
  useCoopConfig,
  precioPorKgPrecargado,
  precioPorKgPorProductor,
  getIdCatCreditoPrecosecha,
} from '../../../components/content/coop-config.jsx';
import transformWord from '../../../utils/transformWord.js';
import moment from 'moment';
import EntregasXProductorBultos from './entregas-x-productor-bultos.js';
import { Productos } from '../../../constants/Productos.js';
import unidadAcopioConvertible from '../../../utils/unidadAcopioConvertible.js';
import limitTwoDecimals from '../../../utils/limitTwoDecimals.js';

let curr = moment(new Date()).toDate();

const EntregasXProductor = () => {
  const MSJ_REQUERIDO = 'Información obligatoria';
  const coopConfig = useCoopConfig();
  const isCafeOrPimienta = () => {
    return [Productos.CAFE, Productos.PIMIENTA].includes(+coopConfig?.config?.cooperativa?.producto?.id);
  };

  const { id_cuenta, uuid_cuenta, uuid_acopio } = useParams();
  const [dataForm, setDataForm] = useState({});
  const [idCatUnidadesEntregas, setIdCatUnidadesEntregas] = useState([]);
  const [idCatCertificacion, setIdCatCertificacion] = useState([]);
  const [pesoNeto, setPesoNeto] = useState();
  const [errorPesoBrutoVsTara, setErrorPesoBrutoVsTara] = useState(false);
  const [importeBruto, setImporteBruto] = useState(null);
  const [montoPagar, setMontoPagar] = useState(0);
  const [pesoDestarado, setPesoDestarado] = useState(0);
  const [showForm, setShowForm] = useState(true);
  const [showFirma, setShowFirma] = useState(false);
  const [metodosPago, setMetodosPago] = useState([]);
  const [coloresMiel, setColoresMiel] = useState([]);
  const [tiposCafe, setTiposCafe] = useState([]);
  const [procesosCafe, setProcesosCafe] = useState([]);
  const [procesosCafeAll, setProcesosCafeAll] = useState([]);
  const [unidadesEntregas, setUnidadesEntregas] = useState([]);
  const [pendientePagoCredito, setPendientePagoCredito] = useState(0);
  const [lotes, setLotes] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [estimacion, setEstimacion] = useState();
  const [entrega, setEntrega] = useState();
  const [cuenta, setCuenta] = useState();
  const [lotesAsignados, setLotesAsignados] = useState([]);
  const [pesoNetoInicial, setPesoNetoInicial] = useState(null);
  const [tieneMultiplesLotes, setTieneMultiplesLotes] = useState(false);
  const [etiquetaAnticipos, setEtiquetaAnticipos] = useState('-');
  const [idMetodoPago, setIdMetodoPago] = useState('');
  const [idColorMiel, setIdColorMiel] = useState('');
  const [idTipoCafe, setIdTipoCafe] = useState('');
  const [idProcesoCafe, setIdProcesoCafe] = useState('');
  const [devuelvenCostaleras, setDevuelvenCostaleras] = useState(null);
  const [anticipoPago, setAnticipoPago] = useState(0);
  const [valuesPesadas, setValuesPesadas] = useState([]);
  const [pesoBrutoTotal, setPesoBrutoTotal] = useState(0);
  const muestreoPermissions = [
    { key: 'rendimiento', permissions: [env.tiposCafe.PERGAMIN_SECO, env.tiposCafe.CEREZO_ARABIGO, env.tiposCafe.CEREZO_ROBUSTA] },
    {
      key: 'humedad',
      permissions: [
        env.tiposCafe.PERGAMIN_SECO,
        env.tiposCafe.CEREZO_ARABIGO,
        env.tiposCafe.CEREZO_ROBUSTA,
        env.tiposCafe.PIMIENTA_GORDA_SECADO,
      ],
    },
    { key: 'mancha', permissions: [env.tiposCafe.PERGAMIN_SECO, env.tiposCafe.CEREZO_ARABIGO, env.tiposCafe.CEREZO_ROBUSTA] },
    { key: 'aroma', permissions: [env.tiposCafe.PERGAMIN_SECO] },
    { key: 'color_de_cafe', permissions: [env.tiposCafe.CEREZO_ARABIGO, env.tiposCafe.CEREZO_ROBUSTA] },
    { key: 'tipo_maduracion', permissions: [env.tiposCafe.CEREZO_UVA] },
  ];
  const [dataEntrega, setDataEntrega] = useState([]);

  useEffect(() => {
    getEtiquetaAnticipo();
  }, [coopConfig.config]);

  const getEtiquetaAnticipo = async () => {
    let etiqueta = await coopConfig.etiquetaAnticipos();
    setEtiquetaAnticipos(etiqueta);
  };

  const customStyles = {
    menu: provided => ({
      ...provided,
      zIndex: 9999,
      position: 'absolute',
      fontSize: '14px',
    }),
    control: base => ({
      ...base,
      fontSize: '14px',
    }),
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: '#666',
        fontSize: '14px',
      };
    },
  };

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="fa fa-search" aria-hidden="true" style={{ position: 'initial' }}></i>
        </components.DropdownIndicator>
      )
    );
  };

  const handleChange = selected => {
    let value = selected?.value ?? null;
    setValue('id_recoleccion_acopio', value);
  };

  useEffect(() => {
    getMetodosPago();
    getColoresMiel();
    getUnidadesEntregas();
    consultaPreciosPrecargados();
    getTiposCafe();
    getProcesosCafePimienta();
  }, []);

  useEffect(() => {
    if (coopConfig?.config && cuenta) {
      getFolio();
    }
  }, [coopConfig?.config, cuenta]);

  useEffect(() => {
    if (tiposCafe.length == 1) {
      handlerSelectTipoCafe(tiposCafe[0].value);
    }
  }, [tiposCafe, procesosCafeAll]);

  useEffect(() => {
    if (procesosCafe.length == 1) {
      handlerSelectProcesoCafe(procesosCafe[0].value);
    }
  }, [procesosCafe]);

  useEffect(() => {
    subscribe('Entrega::onReturn', e => handleReturn(e));
    subscribe('Entrega::Estimacion', e => handleEstimacion(e));
    subscribe('Entrega::Entregas', e => handleEntregas(e));
    subscribe('Entrega::Pagos', e => handlePagos(e));
    subscribe('Entrega::Creditos', e => handleCreditos(e));
    subscribe('Entrega::Cuenta', e => handleCuenta(e));
    return () => {
      unsubscribe('Entrega::onReturn');
      unsubscribe('Entrega::Estimacion');
      unsubscribe('Entrega::Entregas');
      unsubscribe('Entrega::Pagos');
      unsubscribe('Entrega::Creditos');
      unsubscribe('Entrega::Cuenta');
    };
  }, []);

  const handleCuenta = event => {
    setCuenta(event.detail);
  };

  const handleEstimacion = event => {
    setEstimacion(event.detail);
  };

  const handleEntregas = event => {
    setEntrega(event.detail);
  };

  const handlePagos = () => {
    //TODO: remove?
  };

  const handleCreditos = event => {
    setValue('creditos', event.detail.raw);
    setPendientePagoCredito(event.detail.total_saldo);
  };

  const handleReturn = () => {
    setShowForm(true);
    setShowFirma(false);
  };

  const [formData] = useState({
    id_acopio: 0,
    id_cuenta: id_cuenta,
    id_ciclo: localStorage.getItem(`${env.appName}-ciclo_id`),
    uuid: '',
    folio: '',
    fecha_ejecucion: curr,
    fecha_cosecha: null,
    pesadas: [
      {
        id_acopio_pesada: 0,
        id_cat_unidades_entregas: [],
        peso_bruto: '',
        bultos: [],
      },
    ],
    id_acopio_pesada: 0,
    id_acopio_muestreo: 0,
    tipo_maduracion: '',
    rendimiento: '',
    humedad: '',
    mancha: '',
    id_color: '',
    color_de_cafe: '',
    aroma: '',
    muestreo_observaciones: '',
    id_cat_acopio_tipos_cafe: '',
    id_cat_acopio_procesos: '',
    lote: '',
    observaciones: '',
    id_cat_certificacion: '',
    id_acopio_pago: 0,
    precio_por_kg: '',
    precio_por_kg_extra: '',
    peso_neto_pagado: '',
    peso_neto_pagado_anticipo: '',
    recuperacion_credito: '',
    id_metodo_pago: '',
    monto_pagado: '',
    id_recoleccion_acopio: '',
    creditos: [],
    firma_image: '',
    id_cat_costaleras_estatus: null,
    peso_tara: '',
    peso_descuento: '',
    peso_descuento_perc: '',
    peso_descuento_humedad: '',
    peso_descuento_humedad_perc: '',
  });

  const schema = getValidationSchema(coopConfig, valuesPesadas, pendientePagoCredito, anticipoPago, montoPagar, MSJ_REQUERIDO);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
    getValues,
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: 'onBlur',
    defaultValues: formData,
  });

  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: 'pesadas',
  });

  const precioKgValue = watch('precio_por_kg');
  const precioKgExtraValue = watch('precio_por_kg_extra');
  const pesoDescuentoPercValue = watch('peso_descuento_perc');
  const pesoDescuentoHumedadPercValue = watch('peso_descuento_humedad_perc');
  const pesoTaraValue = watch('peso_tara');
  const montoPagado = watch('monto_pagado');
  const recuperacionCredito = watch('recuperacion_credito');

  // update regular price when using price in extra units
  useEffect(() => {
    if (coopConfig.hasAcopioUnitsExtra() && precioKgExtraValue) {
      if (errors.precio_por_kg_extra === undefined) {
        const calculatedPrecioKg = precioKgExtraValue * (coopConfig.acopioUnitsConversion()?.conversion || 1);
        const currentPrecioKg = getValues('precio_por_kg');

        // Only update if the value is actually different to avoid infinite loops
        //TODO: eliminar esta cosa fea creada por la IA
        if (Math.abs(currentPrecioKg - calculatedPrecioKg) > 0.001) {
          const limitedDecimalsPrecioKg = limitTwoDecimals(calculatedPrecioKg);
          setValue('precio_por_kg', limitedDecimalsPrecioKg, { shouldValidate: false });
        }
      } else {
        setValue('precio_por_kg', '');
      }
    }
  }, [precioKgExtraValue, coopConfig, setValue, getValues, errors.precio_por_kg_extra]);

  // update peso neto pagado when using price payments by mass
  useEffect(() => {
    if (montoPagado > 0 && precioKgValue > 0 && coopConfig.acopioPagoXKilos() && errors.precio_por_kg_extra === undefined) {
      setValue('peso_neto_pagado', montoPagado / precioKgValue);
    }
  }, [precioKgValue, montoPagado, setValue]);

  // update recuperacion credito when using price payments by mass
  useEffect(() => {
    if (recuperacionCredito > 0 && precioKgValue > 0 && coopConfig.acopioPagoXKilos() && errors.precio_por_kg_extra === undefined) {
      setValue('peso_neto_pagado_anticipo', recuperacionCredito / precioKgValue);
    }
  }, [precioKgValue, recuperacionCredito, setValue]);

  // block commas in recuperacion_credito (commonly pasted from formatted numbers)
  useEffect(() => {
    if (typeof recuperacionCredito === 'string' && recuperacionCredito.includes(',')) {
      setValue('recuperacion_credito', recuperacionCredito.replace(/,/g, ''), { shouldValidate: true });
    }
  }, [recuperacionCredito, setValue]);

  const isValidPositiveNumber = value => {
    const number = Number(value);
    return !isNaN(number) && number > 0 && !errors.precio_por_kg_extra && !errors.precio_por_kg;
  };

  const handlerSelectChange = (value, index) => {
    setIdCatUnidadesEntregas(value);
    setValue(`pesadas[${index}].id_cat_unidades_entregas`, value);
  };

  const handlerSelectChangeTipos = selectedOption => {
    setIdCatCertificacion(selectedOption);
    let _selectedOption = selectedOption;
    if (_selectedOption.length > 1) {
      // No se puede seleccionar Orgánico y Convencional al mismo tiempo
      let selectedOptionFilter = selectedOption.filter(option => [15, 16].includes(Number(option)));
      if (selectedOptionFilter.length === 2) {
        _selectedOption = selectedOption.filter(option => option !== 16);
      }
    }
    setIdCatCertificacion(_selectedOption);
    setValue('id_cat_certificacion', _selectedOption.join(','));
    clearErrors('id_cat_certificacion');
  };

  const handlerSelectMetodoPago = selectedOption => {
    setIdMetodoPago(selectedOption);
    setValue('id_metodo_pago', selectedOption);
  };

  const handlerSelectColorMiel = selectedOption => {
    setIdColorMiel(selectedOption);
    setValue('id_color', selectedOption);
  };

  const handlerSelectTipoCafe = selectedOption => {
    setIdTipoCafe(selectedOption);
    setValue('id_cat_acopio_tipos_cafe', selectedOption);
    let procesosFiltered = [];
    if (selectedOption === env.tiposCafe.CEREZO_ARABIGO) {
      procesosFiltered = procesosCafeAll.find(proceso => proceso.value == env.procesosCafe.NATURAL);
      if (procesosFiltered) {
        setProcesosCafe([procesosFiltered]);
        setValue('id_cat_acopio_procesos', env.procesosCafe.NATURAL);
      } else {
        setProcesosCafe([]);
        setValue('id_cat_acopio_procesos', '');
      }
    } else if (
      selectedOption === env.tiposCafe.PERGAMIN_SECO ||
      selectedOption === env.tiposCafe.PERGAMINO_HUMEDO ||
      selectedOption === env.tiposCafe.OREADO
    ) {
      const procesosPergaminoSeco = [env.procesosCafe.LAVADO, env.procesosCafe.HONEY, env.procesosCafe.OTRO];
      procesosFiltered = procesosCafeAll.filter(proceso => procesosPergaminoSeco.includes(proceso.value));
      if (procesosFiltered) {
        setProcesosCafe(procesosFiltered);
      } else {
        setProcesosCafe([]);
        setValue('id_cat_acopio_procesos', '');
      }
    } else {
      setProcesosCafe([]);
      setValue('id_cat_acopio_procesos', '');
    }
  };

  const handlerSelectProcesoCafe = selectedOption => {
    setIdProcesoCafe(selectedOption);
    setValue('id_cat_acopio_procesos', selectedOption);
  };

  const onSubmit = values => {
    if (!moment(values.fecha_cosecha).isValid()) values.fecha_cosecha = '';
    setDataForm(values);
    setShowFirma(true);
    setShowForm(false);
  };

  useEffect(() => {
    watch(values => {
      let pesadas = values.pesadas;
      setValuesPesadas(pesadas);
      let _pesoNeto = 0;
      let _pesoDestarado = 0;
      let _importeBruto = 0;
      let hasData = false;

      try {
        // Calculate peso bruto total from all pesadas
        for (let index = 0; index < pesadas.length; index++) {
          if (pesadas[index].peso_bruto > 0) {
            _pesoDestarado += +pesadas[index].peso_bruto;
            hasData = true;
          }
        }
        setPesoBrutoTotal(_pesoDestarado);

        // Calculate peso destarado (peso bruto total - peso tara)
        if (values.peso_tara && +values.peso_tara >= 0) {
          _pesoDestarado = _pesoDestarado - +values.peso_tara;
          hasData = true;
        }

        if (_pesoDestarado > 0) {
          setPesoDestarado(_pesoDestarado);
        }

        // Calculate peso neto (peso destarado - descuentos)
        _pesoNeto = _pesoDestarado;
        if (+values.peso_descuento > 0) {
          _pesoNeto += -+values.peso_descuento;
          hasData = true;
        }
        if (+values.peso_descuento_humedad > 0) {
          _pesoNeto += -+values.peso_descuento_humedad;
          hasData = true;
        }
        if (_pesoNeto > 0) {
          setPesoNeto(_pesoNeto);
          setErrorPesoBrutoVsTara(false);
        } else {
          setPesoNeto(null);
          if (hasData) {
            setErrorPesoBrutoVsTara(true);
          }
        }

        if (values.precio_por_kg > 0) {
          _importeBruto = limitTwoDecimals(_pesoNeto * values.precio_por_kg);
          if (_importeBruto > 0) {
            setImporteBruto(_importeBruto);
          }
        }

        if (values.recuperacion_credito >= 0) {
          if (_importeBruto > 0) {
            setMontoPagar(limitTwoDecimals(_importeBruto - values.recuperacion_credito));
          }
        }
      } catch (error) {
        //console.error(error);
      }
    });
  }, [watch]);

  // Auto-calculate peso_descuento when peso_descuento_perc changes
  useEffect(() => {
    if (coopConfig.mostrarDescuentosPorcentaje() && pesoDescuentoPercValue && pesoDestarado > 0) {
      const calculatedMass = limitTwoDecimals((pesoDestarado * pesoDescuentoPercValue) / 100);
      setValue('peso_descuento', calculatedMass);
    }
  }, [pesoDescuentoPercValue, pesoDestarado, setValue, coopConfig]);

  // Auto-calculate peso_descuento_humedad when peso_descuento_humedad_perc changes
  useEffect(() => {
    if (coopConfig.mostrarDescuentosPorcentaje() && pesoDescuentoHumedadPercValue && pesoDestarado > 0) {
      const calculatedMass = limitTwoDecimals((pesoDestarado * pesoDescuentoHumedadPercValue) / 100);
      setValue('peso_descuento_humedad', calculatedMass);
    }
  }, [pesoDescuentoHumedadPercValue, pesoDestarado, setValue, coopConfig]);

  const getUnidadesEntregas = () => {
    Api.getAll('acopios/catalogos/unidades_entrega').then(response => {
      let _items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'] };
      });
      setUnidadesEntregas(_items);
    });
  };

  const getMetodosPago = () => {
    Api.getAll('acopios/catalogos/metodos_pago').then(response => {
      let _items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'] };
      });
      setMetodosPago(_items);
      if (_items.length === 1) {
        setIdMetodoPago(_items[0].value);
        setValue('id_metodo_pago', _items[0].value);
      }
    });
  };

  const getColoresMiel = () => {
    Api.getAll('acopios/catalogos/colores_miel').then(response => {
      let _items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'], color: item['color'] };
      });
      setColoresMiel(_items);
    });
  };

  const getTiposCafe = () => {
    if (isCafeOrPimienta()) {
      Api.getAll('acopios/catalogos/tipos_cafe').then(response => {
        const items = response.data.map(item => {
          return { value: item['id'], label: item['nombre'] };
        });
        setTiposCafe(items);
      });
    }
  };

  const getProcesosCafePimienta = () => {
    if (isCafeOrPimienta()) {
      Api.getAll('acopios/catalogos/procesos_cafe').then(response => {
        const items = response.data.map(item => {
          return { value: item['id'], label: item['nombre'] };
        });
        setProcesosCafeAll(items);
      });
    }
  };

  const checkTipoProducto = (key, idKey = idTipoCafe) => {
    const permissions = muestreoPermissions.find(m => m.key == key)?.permissions;
    return permissions ? permissions.includes(idKey) : false;
  };

  useEffect(() => {
    if (uuid_acopio !== undefined && unidadesEntregas.length > 0) {
      getDataEntrega();
    }
  }, [uuid_acopio, unidadesEntregas, tipos]);

  const setdatosGenerales = (data, recoleccionAcopiosPesos = []) => {
    setValue('id_acopio', data.id);
    setValue('uuid', data.uuid);
    setValue('fecha_ejecucion', moment(data.fecha_ejecucion).toDate());
    setValue('folio', data.folio);
    moment(data.fecha_cosecha).isValid() && setValue('fecha_cosecha', moment(data.fecha_cosecha).toDate());
    setDevuelvenCostaleras(data.id_cat_costaleras_estatus);
    setValue('id_cat_costaleras_estatus', data.id_cat_costaleras_estatus);
    if (recoleccionAcopiosPesos.length === 1) {
      setValue('id_recoleccion_acopio', recoleccionAcopiosPesos[0]?.id_recoleccion_acopio);
    } else {
      setValue('id_recoleccion_acopio', data.id_recoleccion_acopio);
    }
    setValue('id_cat_acopio_tipos_cafe', data.id_cat_acopio_tipos_cafe);
    setValue('id_cat_acopio_procesos', data.id_cat_acopio_procesos);
    setValue('peso_tara', data.peso_tara / 100);
    setValue('peso_descuento', data.peso_descuento / 100);
    setValue('peso_descuento_humedad', data.peso_descuento_humedad / 100);
    if (coopConfig.mostrarDescuentosPorcentaje()) {
      let pesoDestarado = data.peso_bruto - data.peso_tara;
      setValue('peso_descuento_perc', (data.peso_descuento / pesoDestarado) * 100);
      setValue('peso_descuento_humedad_perc', (data.peso_descuento_humedad / pesoDestarado) * 100);
    }
    setValue('observaciones', data.observaciones);
    setIdTipoCafe(+data.id_cat_acopio_tipos_cafe);
  };

  const getUnidadesEntrega = (id_acopio_pesadas, acopio_pesada_cat_unidades) => {
    let unidades = [];
    acopio_pesada_cat_unidades
      .filter(apcu => Number(apcu.id_acopio_pesadas) === Number(id_acopio_pesadas))
      .reduce(function(prev, curr) {
        return unidades.push(Number(curr.id_cat_unidades_entregas));
      }, null);
    return unidades;
  };

  const setdatosBultos = (id_acopio_pesadas, acopio_pesada_cat_unidades) => {
    let bultos_data = acopio_pesada_cat_unidades.filter(unidad => Number(unidad.id_acopio_pesadas) === Number(id_acopio_pesadas));
    return bultos_data;
  };

  const setdatosPesada = (acopio_pesadas, acopio_pesada_cat_unidades) => {
    const pesadasData = acopio_pesadas.map(pesada => {
      const id_cat_unidades_entregas = getUnidadesEntrega(pesada.id, acopio_pesada_cat_unidades);

      return {
        id_acopio_pesadas: pesada.id,
        id_cat_unidades_entregas: id_cat_unidades_entregas || [],
        peso_bruto: pesada.peso_bruto / 100,
        bultosData: setdatosBultos(pesada.id, acopio_pesada_cat_unidades),
      };
    });

    pesadasData.forEach((pesada, index) => {
      setValue(`pesadas[${index}]`, pesada);
      remove(index);
      insert(index, pesada);
    });
  };

  const setdatosTipos = acopio_tipos => {
    let tiposArr = [];
    for (let u = 0; u < acopio_tipos.length; u++) {
      tiposArr.push(Number(acopio_tipos[u].id_cat_certificacion));
    }

    setIdCatCertificacion(tiposArr);
    setValue('id_cat_certificacion', tiposArr.join(','));
  };

  const setdatosMuestreo = acopio_muestreos => {
    if (typeof acopio_muestreos[0] !== 'undefined') {
      setValue('id_acopio_muestreo', acopio_muestreos[0].id ?? '');
      setValue('tipo_maduracion', acopio_muestreos[0].tipo_maduracion ?? '');
      setValue('rendimiento', acopio_muestreos[0].rendimiento ?? '');
      setValue('humedad', acopio_muestreos[0].humedad ?? '');
      setValue('mancha', acopio_muestreos[0].mancha ?? '');
      setValue('muestreo_observaciones', acopio_muestreos[0].observaciones ?? '');
      setValue('id_color', acopio_muestreos[0].id_color ?? '');
      setValue('color_de_cafe', acopio_muestreos[0].color_de_cafe ?? '');
      setValue('aroma', acopio_muestreos[0].aroma ?? '');
      setIdColorMiel(acopio_muestreos[0].id_color);
    }
  };

  const setdatosPago = (acopio_pagos, precio_por_kg, recuperado_credito) => {
    let _precio = Number.isNaN(precio_por_kg) ? '' : Math.round(precio_por_kg * 100) / 100;
    setValue('precio_por_kg', limitTwoDecimals(_precio / 100));
    setValue('precio_por_kg_extra', _precio);
    if (coopConfig.hasAcopioUnitsExtra()) {
      setValue('precio_por_kg', limitTwoDecimals((_precio * coopConfig.acopioUnitsConversion()?.conversion) / 100));
    }

    if (typeof acopio_pagos[0] !== 'undefined') {
      setValue('id_acopio_pago', acopio_pagos[0].id);
      setValue('folio', acopio_pagos[0].folio);
      setValue('id_centro_acopio', acopio_pagos[0].id_centro_acopio);
      let id_metodo_pago = metodosPago.filter(metodo => [Number(acopio_pagos[0].id_metodo_pago)].includes(metodo.value));
      if (id_metodo_pago.length === 1) {
        setValue('id_metodo_pago', id_metodo_pago[0].value);
        setIdMetodoPago(id_metodo_pago[0].value);
      }
      let monto_pagado = 0;
      acopio_pagos.forEach(ap => {
        monto_pagado += ap.total > 0 ? ap.total / 100 : Number(ap.total);
      });
      if (monto_pagado > 0) {
        setValue('monto_pagado', monto_pagado);
      }
      if (recuperado_credito > 0) {
        setValue('recuperacion_credito', recuperado_credito);
      }

      setValue('firma_image', acopio_pagos[0].firma_image);
    }
  };

  const getDataEntrega = () => {
    Api.get('admin/acopios/entregas', uuid_acopio).then(response => {
      if (response.status === 200) {
        let dataEntrega = response.data;
        setDataEntrega(dataEntrega);
        if (typeof dataEntrega.id !== 'undefined') {
          const recoleccionAcopiosPesos = dataEntrega.recoleccion_acopios_pesos || [];
          setLotesAsignados(recoleccionAcopiosPesos);
          setTieneMultiplesLotes(recoleccionAcopiosPesos.length >= 2);

          let _pesoNeto =
            Number(dataEntrega.peso_bruto) -
            Number(dataEntrega.peso_tara) -
            Number(dataEntrega.peso_descuento) -
            Number(dataEntrega.peso_descuento_humedad);
          const recuperado_credito = dataEntrega.anticipo_pagos.reduce((acc, curr) => acc + curr.cantidad_pago / 100, 0);
          setdatosGenerales(dataEntrega, recoleccionAcopiosPesos);
          setdatosPesada(dataEntrega.acopio_pesadas, dataEntrega.acopio_pesada_cat_unidades);
          setdatosMuestreo(dataEntrega.acopio_muestreos);
          setdatosPago(dataEntrega.acopio_pagos, dataEntrega.precio_por_kg, recuperado_credito);
          setdatosTipos(dataEntrega.acopio_tipos);
          setPesoNeto(Number(_pesoNeto) / 100);
          setPesoNetoInicial(Number(_pesoNeto) / 100);
          setAnticipoPago(recuperado_credito);
          setImporteBruto(limitTwoDecimals(((Number(_pesoNeto) / 100) * Number(dataEntrega.precio_por_kg)) / 100));
        }
      }
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  const mostrarLeyendaCambioPeso =
    tieneMultiplesLotes && pesoNetoInicial !== null && pesoNeto !== null && Math.abs(Number(pesoNeto) - Number(pesoNetoInicial)) > 0.0001;

  useEffect(() => {
    getTipos();
    getLotes();
  }, []);

  const getLotes = () => {
    Api.get('admin/acopios/entregas/lotes', localStorage.getItem(`${env.appName}-ciclo_id`)).then(response => {
      let _lotes = [];
      _lotes.push({ value: '', label: 'Sin Asignar', folio: null, volumen: null });
      response.data.map(function(item) {
        _lotes.push({
          value: item['id'],
          label: item['nombre'] + (item['folio'] ? ' | ' + item['folio'] : ''),
          folio: item['folio'],
          volumen: item['volumen'],
        });
      });
      setLotes(_lotes);
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  const getTipos = () => {
    Api.getAll('acopios/catalogos/certificaciones').then(response => {
      let _items = response.data.map(function(item) {
        return {
          value: item['id'],
          label: item['nombre'],
        };
      });
      setTipos(_items);
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  const agregaPesada = () => {
    const newPesada = {
      id_acopio_pesadas: 0,
      id_cat_unidades_entregas: [],
      peso_bruto: '',
      no_bultos: '',
      no_costales: '',
      no_tambores: '',
      no_sacos: '',
      no_costalillos: '',
      no_botes: '',
      bolsa_plastico: '',
      costal_yute: '',
      costal_pergaminero: '',
    };

    if (+coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL) {
      newPesada.tambor = '';
    }

    append(newPesada);
  };

  const eliminaPesada = index => {
    remove(index);
  };

  const setPrecios = precio => {
    if (coopConfig.hasAcopioUnitsExtra()) {
      setValue('precio_por_kg', limitTwoDecimals(precio * coopConfig.acopioUnitsConversion()?.conversion));
      setValue('precio_por_kg_extra', precio);
    } else {
      setValue('precio_por_kg', precio);
    }
  };

  const getFolio = () => {
    if (typeof uuid_acopio === 'undefined') {
      const iniciales = coopConfig?.config?.cooperativa?.iniciales;
      const cicloId = localStorage.getItem(`${env.appName}-ciclo_id`);
      const idCentroAcopio = cuenta?.id_centro_acopio;
      const uuid = uuidv4().slice(-5);
      const folio = iniciales + idCentroAcopio + cicloId + '-' + uuid.slice(-5);
      setValue('folio', folio);
    }
  };

  const consultaPreciosPrecargados = () => {
    if (typeof uuid_acopio === 'undefined') {
      // Si es registro nuevo se consultan los precios precargados
      consultaPrecioPorCoop();
      consultaPrecioPorProductor();
      return;
    }
  };

  const consultaPrecioPorCoop = () => {
    if (precioPorKgPrecargado()) {
      // Obneter el precio por cooperativa
      Api.getAll('admin/acopios/precio_por_kg_precargado').then(response => {
        if (typeof response.data[0] !== 'undefined') {
          if (typeof response.data[0].precio !== 'undefined') {
            setPrecios(response.data[0].precio);
          }
        }
      });
    }
  };

  const consultaPrecioPorProductor = () => {
    if (precioPorKgPrecargado()) {
      if (precioPorKgPorProductor()) {
        // Obneter el precio por productor
        Api.get('admin/acopios/precio_por_kg_por_productor', id_cuenta).then(response => {
          if (typeof response.data[0] !== 'undefined') {
            if (typeof response.data[0].precio !== 'undefined') {
              setPrecios(response.data[0].precio);
            }
          }
        });
      }
    }
  };

  return (
    <div>
      <div className="mb-3">
        <EntregasXProductorBuscador uuid_cuenta={uuid_cuenta} />
      </div>

      <CardContainer height={'100%'}>
        <div className="row">
          <div className="col-md-12 col-lg-7">
            {showForm && (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col">
                    <h3>{'Registro de nueva entrega'}</h3>

                    {/* Tipo de entrega inputs */}
                    <div className="row pt-3 pl-2">
                      <p className="titulo-input">Tipo de entrega</p>
                    </div>

                    <div className="row mb-4">
                      <div className="col-md-4">
                        <FormInputMaterialTest
                          id="folio"
                          name="folio"
                          label=""
                          placeholder="Folio"
                          error={errors.folio}
                          register={register}
                          defaultValue={getValues().folio}
                        />
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-md-4">
                        <Controller
                          control={control}
                          name="fecha_ejecucion"
                          render={({ field }) => (
                            <DatePicker
                              customInput={<ExampleCustomInput />}
                              dateFormat={'dd/MMM/yyyy'}
                              onChange={date => field.onChange(date)}
                              selected={field.value}
                              ariaLabelledBy="cosa"
                              previousMonthButtonLabel=""
                              nextMonthButtonLabel=""
                              wrapperClassName="w-100"
                              locale={es}
                            />
                          )}
                        />
                        {errors?.fecha_ejecucion && <div className="invalid-feedback">{errors?.fecha_ejecucion.message}</div>}
                      </div>
                    </div>

                    {isCafeOrPimienta() && (
                      <div className="row mb-4">
                        <div className="col-md-9">
                          <Controller
                            control={control}
                            name="id_cat_acopio_tipos_cafe"
                            render={() => (
                              <FormSelectMaterial
                                placeholder={`Tipo de ${transformWord(coopConfig.config.cooperativa.producto.nombre, [
                                  'singular',
                                  'lowercase',
                                ])}`}
                                label={`Tipo de ${transformWord(coopConfig.config.cooperativa.producto.nombre, ['singular', 'lowercase'])}`}
                                options={tiposCafe}
                                id={'id_cat_acopio_tipos_cafe'}
                                error={errors.id_cat_acopio_tipos_cafe}
                                register={register}
                                onChange={handlerSelectTipoCafe}
                                value={idTipoCafe != '' ? idTipoCafe : getValues().id_cat_acopio_tipos_cafe || ''}
                              />
                            )}
                          />
                          {errors?.id_cat_acopio_tipos_cafe && (
                            <div className="invalid-feedback">{errors?.id_cat_acopio_tipos_cafe.message}</div>
                          )}
                        </div>
                        {procesosCafe.length > 0 && (
                          <div className="col-md-9 mt-4">
                            <Controller
                              control={control}
                              name="id_cat_acopio_procesos"
                              render={() => (
                                <FormSelectMaterial
                                  placeholder="Proceso"
                                  label="Proceso"
                                  options={procesosCafe}
                                  id={'id_cat_acopio_procesos'}
                                  error={errors.id_cat_acopio_procesos}
                                  register={register}
                                  onChange={handlerSelectProcesoCafe}
                                  value={idProcesoCafe != '' ? idProcesoCafe : getValues().id_cat_acopio_procesos || ''}
                                />
                              )}
                            />
                            {errors?.id_cat_acopio_procesos && (
                              <div className="invalid-feedback">{errors?.id_cat_acopio_procesos.message}</div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {coopConfig.mostrarTipo() && (
                      <div className="row mb-4">
                        <div className="col-md-9">
                          <Controller
                            control={control}
                            name="id_cat_certificacion"
                            render={() => (
                              <FormSelectMaterial
                                placeholder="Categoría"
                                label="Categoría"
                                options={tipos}
                                name={'id_cat_certificacion'}
                                multiple={true}
                                error={errors?.id_cat_certificacion}
                                register={register}
                                onChange={handlerSelectChangeTipos}
                                value={idCatCertificacion || ''}
                              />
                            )}
                          />
                          {errors?.id_cat_certificacion && <div className="invalid-feedback">{errors?.id_cat_certificacion.message}</div>}
                          {cuenta?.cuenta_categoria !== 'Orgánico' && idCatCertificacion.includes(15) && (
                            <div className="invalid-feedback">
                              La categoría del productor no es orgánica. ¿Está seguro/a de esta categoría?
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {coopConfig.mostrarCostalera() && (
                      <>
                        <div className="row mt-1">
                          <div className="col">
                            <p className="titulo-pregunta">{'¿Se devuelven costaleras a la cooperativa?'}</p>
                          </div>
                        </div>

                        <div className="row g-3 mb-4 align-items-center">
                          <div className="col-auto">
                            <input
                              type="radio"
                              name="id_cat_costaleras_estatus"
                              value={1}
                              checked={Number(devuelvenCostaleras) === 1}
                              onChange={() => {
                                setValue('id_cat_costaleras_estatus', 1);
                                setDevuelvenCostaleras(1);
                              }}
                            />{' '}
                            Si
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              name="id_cat_costaleras_estatus"
                              value={0}
                              checked={Number(devuelvenCostaleras) === 2}
                              onChange={() => {
                                setValue('id_cat_costaleras_estatus', 2);
                                setDevuelvenCostaleras(2);
                              }}
                            />{' '}
                            No
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              name="id_cat_costaleras_estatus"
                              value={0}
                              checked={devuelvenCostaleras === null}
                              onChange={() => {
                                setValue('id_cat_costaleras_estatus', null);
                                setDevuelvenCostaleras(null);
                              }}
                            />{' '}
                            No aplica
                          </div>

                          {errors?.id_cat_costaleras_estatus && (
                            <div className="invalid-feedback">{errors?.id_cat_costaleras_estatus.message}</div>
                          )}
                        </div>
                      </>
                    )}

                    {+coopConfig?.config?.cooperativa?.producto?.id === Productos.MIEL && (
                      <>
                        <div className="row mb-4 mt-2">
                          <div className="col-md-4">
                            <p className="titulo-pregunta mb-1">{'Fecha de cosecha'}</p>
                            <Controller
                              control={control}
                              name="fecha_cosecha"
                              render={({ field }) => (
                                <DatePicker
                                  customInput={<ExampleCustomInput />}
                                  dateFormat={'dd/MMM/yyyy'}
                                  onChange={date => field.onChange(date)}
                                  selected={field.value}
                                  wrapperClassName="w-100"
                                  locale={es}
                                />
                              )}
                            />
                            {errors?.fecha_cosecha && <div className="invalid-feedback">{errors?.fecha_cosecha.message}</div>}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Datos de la pesada inputs */}
                <div className="row pt-3 pl-2">
                  <p className="titulo-input">Datos de pesada</p>
                </div>

                <div className="row pl-2 mt-2">
                  {estimacion && entrega && estimacion?.est_peso_estimado_total > 0 && (
                    <p className="info-input">
                      {'A este productor/a le faltan ' +
                        unidadAcopioConvertible(
                          (estimacion?.est_peso_estimado_total || 0) - (entrega?.entregas_peso_neto_total || 0),
                          coopConfig
                        ) +
                        ' para completar su estimación de cosecha'}
                    </p>
                  )}
                </div>

                {fields.map((pesada, index) => (
                  <div key={index}>
                    {fields.length > 1 && <h4 className="mt-1 mb-3">{'Pesada: ' + (index + 1)}</h4>}
                    <div className="row">
                      <div className="col-md-9">
                        <FormSelectMaterial
                          placeholder="Recipientes de entrega"
                          label="Recipientes de entrega"
                          options={unidadesEntregas}
                          name={`pesadas[${index}].id_cat_unidades_entregas`}
                          multiple={true}
                          error={errors.pesadas?.[index]?.id_cat_unidades_entregas}
                          register={register}
                          onChange={data => handlerSelectChange(data, index)}
                          value={getValues().pesadas[index].id_cat_unidades_entregas || ''}
                        />

                        {errors.pesadas?.[index]?.id_cat_unidades_entregas && (
                          <div className="invalid-feedback">{errors.pesadas?.[index]?.id_cat_unidades_entregas.message}</div>
                        )}
                      </div>
                    </div>
                    <EntregasXProductorBultos
                      errors={errors}
                      unidadesEntregas={unidadesEntregas}
                      id_cat_unidades_entregas={getValues().pesadas[index]?.id_cat_unidades_entregas}
                      nestIndex={index}
                      values={getValues()}
                      setValue={setValue}
                      {...{ control, register }}
                    />
                    {+coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL && (
                      <div className="row mt-4">
                        <div className="col-md-9">
                          <FormInputMaterialTest
                            id={`pesadas[${index}].tambor`}
                            register={register}
                            control={control}
                            error={errors.pesadas?.[index]?.tambor}
                            placeholder={'Tambor'}
                            label=""
                            step=".01"
                            value={getValues().pesadas[index]?.tambor}
                          />
                        </div>
                      </div>
                    )}
                    <div className="row mt-4">
                      <div className="col-md-9">
                        <FormInputMaterialTest
                          id={`pesadas[${index}].peso_bruto`}
                          register={register}
                          control={control}
                          error={errors.pesadas?.[index]?.peso_bruto}
                          placeholder={`Peso bruto (${coopConfig.acopioUnits()?.abreviacion})`}
                          label=""
                          step=".01"
                          value={getValues().pesadas[index]?.peso_bruto}
                        />
                      </div>

                      {index > 0 && (
                        <div className="col-md-3">
                          <button
                            className="btn btn-outline-danger mx-1"
                            type="button"
                            onClick={() => {
                              eliminaPesada(index);
                            }}>
                            Eliminar
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div className="row">
                  <button className="btn btn-default col-md-3 mt-3" type="button" onClick={agregaPesada}>
                    Agrega otra pesada
                  </button>
                </div>
                <div className="row pt-3 pl-2">
                  <p className="titulo-input">{'Totales'}</p>
                </div>

                {getValues().pesadas.length > 1 && (
                  <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="col-md-9">
                      <p className="info-input" style={{ marginTop: 0, marginBottom: '3px' }}>
                        Peso bruto total ={' '}
                        <span style={{ fontSize: 16 }}>
                          {formatMoneyNumber(pesoBrutoTotal) + ' ' + coopConfig.acopioUnits()?.abreviacion}
                        </span>
                      </p>
                    </div>
                  </div>
                )}

                <div className="row mt-4" style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="col-md-9">
                    <FormInputMaterialTest
                      id={`peso_tara`}
                      register={register}
                      control={control}
                      error={errors.peso_tara}
                      placeholder={`Peso tara (${coopConfig.acopioUnits()?.abreviacion})`}
                      label=""
                      step=".01"
                      value={getValues().peso_tara}
                    />
                  </div>
                  {coopConfig.mostrarDescuentosPorcentaje() && pesoTaraValue > 0 && (
                    <div className="col-md-9">
                      <p className="info-input" style={{ marginTop: 0, marginBottom: '3px' }}>
                        Peso destarado ={' '}
                        <span style={{ fontSize: 16 }}>
                          {formatMoneyNumber(pesoDestarado) + ' ' + coopConfig.acopioUnits()?.abreviacion}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                {coopConfig.mostrarDescuento() && (
                  <div className="row mt-4" style={{ display: 'flex', alignItems: 'center' }}>
                    {coopConfig.mostrarDescuentosPorcentaje() ? (
                      <>
                        <div className="col-md-9">
                          <FormInputMaterialTest
                            id={`peso_descuento_perc`}
                            register={register}
                            control={control}
                            error={errors.peso_descuento_perc}
                            placeholder={`Descuento${coopConfig.mostrarDescuentoHumedad() ? ' calidad' : ''} (%)`}
                            label=""
                            step=".01"
                            value={getValues().peso_descuento_perc}
                          />
                        </div>
                        {pesoDestarado > 0 && getValues().peso_descuento_perc > 0 && (
                          <div className="col-md-9">
                            <p className="info-input" style={{ marginTop: 0, marginBottom: '3px' }}>
                              Peso descuento {coopConfig.mostrarDescuentoHumedad() ? 'calidad ' : ''}={' '}
                              <span style={{ fontSize: 16 }}>
                                {formatMoneyNumber((pesoDestarado * getValues().peso_descuento_perc) / 100) +
                                  ' ' +
                                  coopConfig.acopioUnits()?.abreviacion}
                              </span>
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="col-md-9">
                        <FormInputMaterialTest
                          id={`peso_descuento`}
                          register={register}
                          control={control}
                          error={errors.peso_descuento}
                          placeholder={`Peso descuento${coopConfig.mostrarDescuentoHumedad() ? ' calidad' : ''} (${
                            coopConfig.acopioUnits()?.abreviacion
                          }.)`}
                          label=""
                          step=".01"
                          value={getValues().peso_descuento}
                        />
                      </div>
                    )}
                  </div>
                )}
                {coopConfig.mostrarDescuentoHumedad() && (
                  <div className="row mt-4" style={{ display: 'flex', alignItems: 'center' }}>
                    {coopConfig.mostrarDescuentosPorcentaje() ? (
                      <>
                        <div className="col-md-9">
                          <FormInputMaterialTest
                            id={`peso_descuento_humedad_perc`}
                            register={register}
                            control={control}
                            error={errors.peso_descuento_humedad_perc}
                            placeholder={`Descuento humedad (%)`}
                            label=""
                            step=".01"
                            value={getValues().peso_descuento_humedad_perc}
                          />
                        </div>
                        {pesoDestarado > 0 && getValues().peso_descuento_humedad_perc > 0 && (
                          <div className="col-md-9">
                            <p className="info-input" style={{ marginTop: 0, marginBottom: '3px' }}>
                              Peso descuento humedad ={' '}
                              <span style={{ fontSize: 16 }}>
                                {formatMoneyNumber((pesoDestarado * getValues().peso_descuento_humedad_perc) / 100) +
                                  ' ' +
                                  coopConfig.acopioUnits()?.abreviacion}
                              </span>
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="col-md-3">
                        <FormInputMaterialTest
                          id={`peso_descuento_humedad`}
                          register={register}
                          control={control}
                          error={errors.peso_descuento_humedad}
                          placeholder={`Peso descuento humedad (${coopConfig.acopioUnits()?.abreviacion})`}
                          label=""
                          step=".01"
                          value={getValues().peso_descuento_humedad}
                        />
                      </div>
                    )}
                  </div>
                )}
                {pesoNeto && (
                  <div className="row pl-2 mt-2">
                    <p className={formatMoneyNumber(pesoNeto) >= 0 ? 'info-input' : 'in-valid'}>
                      Peso neto {'  '}
                      <span>&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;</span>
                      <span style={{ fontSize: 24 }}>
                        {formatMoneyNumber(pesoNeto) + ' ' + coopConfig.acopioUnits()?.abreviacion}
                        {coopConfig.acopioUnitsExtra() ? (
                          <span>
                            &nbsp;&nbsp;(
                            {formatMoneyNumber(pesoNeto * (coopConfig.acopioUnitsConversion()?.conversion || 1))}{' '}
                            {coopConfig.acopioUnitsExtra()?.abreviacion})
                          </span>
                        ) : null}
                      </span>
                    </p>
                    {pesoNeto > estimacion?.est_peso_estimado_total ? (
                      coopConfig.acopioUnitsExtra() ? (
                        <div className="">
                          ⚠️ El peso neto total{' '}
                          <b>
                            {/* {formatMoneyNumber(pesoNeto) + ' ' + coopConfig.acopioUnits()?.abreviacion} */}
                            <span>
                              &nbsp;&nbsp;
                              {formatMoneyNumber(pesoNeto * (coopConfig.acopioUnitsConversion()?.conversion || 1))}{' '}
                              {coopConfig.acopioUnitsExtra()?.abreviacion}
                            </span>
                          </b>{' '}
                          es mayor que la estimación de cosecha pendiente por entregar:{' '}
                          <b>
                            {/* {formatMoneyNumber(estimacion?.est_peso_estimado_total || 0)} {coopConfig.acopioUnits()?.abreviacion} */}
                            <span>
                              &nbsp;&nbsp;
                              {formatMoneyNumber(
                                estimacion?.est_peso_estimado_total * (coopConfig.acopioUnitsConversion()?.conversion || 1)
                              )}{' '}
                              {coopConfig.acopioUnitsExtra()?.abreviacion}
                            </span>
                          </b>{' '}
                        </div>
                      ) : (
                        <div className="">
                          ⚠️ El peso neto total{' '}
                          <b>
                            {pesoNeto} - {coopConfig.acopioUnits()?.abreviacion}
                          </b>{' '}
                          es mayor que la estimación de cosecha pendiente por entregar:{' '}
                          <b>
                            {formatMoneyNumber(estimacion?.est_peso_estimado_total || 0)} {coopConfig.acopioUnits()?.abreviacion}
                          </b>{' '}
                        </div>
                      )
                    ) : null}
                  </div>
                )}
                {errorPesoBrutoVsTara && (
                  <div className="row pl-2 mt-2">
                    <h4 className="invalid-feedback">
                      {coopConfig.mostrarDescuento()
                        ? 'El peso bruto debe ser mayor a la suma de peso tara y descuentos'
                        : 'El peso bruto debe ser mayor al peso tara'}
                    </h4>
                  </div>
                )}

                {/* Muestreo */}
                {coopConfig.mostrarMuestreo && (
                  <>
                    <div className="row pt-3 pl-2">
                      <p className="titulo-input">{'Muestreo'}</p>
                    </div>

                    {!!+coopConfig?.config?.config_muestreo?.mostrar_tipo_maduracion && checkTipoProducto('tipo_maduracion') && (
                      <div className="row">
                        <div className="col-4 mb-4">
                          <FormInputMaterialTest
                            id="tipo_maduracion"
                            name="tipo_maduracion"
                            label=""
                            placeholder="Maduración (describe)"
                            error={errors.tipo_maduracion}
                            register={register}
                            defaultValue={getValues().tipo_maduracion}
                          />
                        </div>
                      </div>
                    )}
                    <div className="row">
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_rendimiento && checkTipoProducto('rendimiento') && (
                        <div className="col-md-4 mb-4">
                          <FormInputMaterialTest
                            id="rendimiento"
                            name="rendimiento"
                            label=""
                            placeholder="Rendimiento (%)"
                            error={errors.rendimiento}
                            register={register}
                            step=".01"
                            defaultValue={getValues().rendimiento}
                          />
                        </div>
                      )}

                      {!!+coopConfig?.config?.config_muestreo?.mostrar_humedad &&
                        (checkTipoProducto('humedad') || +coopConfig?.config?.cooperativa?.producto?.id === Productos.MIEL) && (
                          <div className="col-md-4 mb-4">
                            <FormInputMaterialTest
                              id="humedad"
                              name="humedad"
                              label=""
                              placeholder="Humedad (%)"
                              error={errors.humedad}
                              register={register}
                              step=".01"
                              defaultValue={getValues().humedad}
                            />
                          </div>
                        )}
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_mancha && checkTipoProducto('mancha') && (
                        <div className="col-md-4 mb-4">
                          <FormInputMaterialTest
                            id="mancha"
                            name="mancha"
                            label=""
                            placeholder="Mancha (%)"
                            error={errors.mancha}
                            register={register}
                            step=".01"
                            defaultValue={getValues().mancha}
                          />
                        </div>
                      )}
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_color_de_cafe && checkTipoProducto('color_de_cafe') && (
                        <div className="col-md-4 mb-4">
                          <FormInputMaterialTest
                            id="color_de_cafe"
                            name="color_de_cafe"
                            label=""
                            placeholder="Color (describe)"
                            error={errors.color_de_cafe}
                            register={register}
                            defaultValue={getValues().aroma}
                          />
                        </div>
                      )}
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_color && (
                        <div className="col-md-4 mb-4">
                          <FormSelectMaterial
                            placeholder="Color"
                            label="Color"
                            options={coloresMiel}
                            id={'id_color'}
                            error={errors.id_color}
                            register={register}
                            onChange={handlerSelectColorMiel}
                            value={idColorMiel || ''}
                          />
                          {errors?.id_color && <div className="invalid-feedback">{errors?.id_color.message}</div>}
                        </div>
                      )}
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_aroma && checkTipoProducto('aroma') && (
                        <div className="col-md-4 mb-4">
                          <FormInputMaterialTest
                            id="aroma"
                            name="aroma"
                            label=""
                            placeholder="Aroma (describe)"
                            error={errors.aroma}
                            register={register}
                            defaultValue={getValues().color_de_cafe}
                          />
                        </div>
                      )}
                      {!!+coopConfig?.config?.config_muestreo?.mostrar_observaciones && (
                        <div className="col-md-4 mb-4">
                          <FormInputMaterialTest
                            id="muestreo_observaciones"
                            name="muestreo_observaciones"
                            label=""
                            placeholder="Observaciones"
                            error={errors.muestreo_observaciones}
                            register={register}
                            defaultValue={getValues().muestreo_observaciones}
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {/* Lotes */}
                {coopConfig.mostrarLote() && (
                  <>
                    {tieneMultiplesLotes ? (
                      <>
                        {mostrarLeyendaCambioPeso && (
                          <div className="row mt-3 pl-2 mb-4">
                            <div className="alert alert-warning" style={{ marginBottom: 0 }}>
                              Ya que la entrega esta asociada a mas de un lote, se eliminara la asociacion, debera asociar de nuevo la
                              entrega a los lotes necesarios
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="row pt-3 pl-2">
                          <p className="titulo-input">
                            Lote
                            <span style={{ fontSize: 10, paddingLeft: 5 }}>¿Quieres asignar a esta entrega un lote?</span>
                          </p>
                        </div>

                        <div className="row">
                          <div className="col-md-9 mb-4">
                            <Controller
                              control={control}
                              name="id_recoleccion_acopio"
                              render={() => (
                                <Select
                                  isLoading={lotes.length === 0}
                                  components={{ DropdownIndicator }}
                                  classNamePrefix="_select_"
                                  isSearchable={true}
                                  isClearable={true}
                                  autosize={false}
                                  style={{ zIndex: 50, opacity: 1 }}
                                  styles={customStyles}
                                  placeholder="Nº o código de lote"
                                  options={lotes}
                                  noOptionsMessage={() => 'No hay elementos por mostrar'}
                                  onChange={handleChange}
                                  input={provided => ({
                                    ...provided,
                                    input: {
                                      opacity: '1 !important',
                                    },
                                  })}
                                  value={lotes.filter(unidad => unidad.value === getValues().id_recoleccion_acopio)}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {/* Orphan columns */}
                <div className="row">
                  <div className="col-md-9 mb-4">
                    <FormInputMaterialTest
                      id="observaciones"
                      name="observaciones"
                      label=""
                      placeholder="Observaciones"
                      error={errors.observaciones}
                      register={register}
                      value={getValues().observaciones}
                    />
                  </div>
                </div>

                {/* Pagos */}
                <div className="row pt-3 pl-2">
                  <p className="titulo-input">{'Pago'}</p>
                </div>

                <div className="row mb-2">
                  {coopConfig.hasAcopioUnitsExtra() ? (
                    <div className="col-7">
                      <FormInputMaterialTest
                        id="precio_por_kg_extra"
                        name="precio_por_kg_extra"
                        label=""
                        placeholder={`Precio / ${coopConfig.acopioUnitsExtra()?.abreviacion} (${coopConfig.currency()?.symbol})`}
                        error={errors.precio_por_kg_extra}
                        register={register}
                        step=".01"
                        value={getValues().precio_por_kg_extra}
                      />
                    </div>
                  ) : (
                    <div className="col-md-9">
                      <FormInputMaterialTest
                        id="precio_por_kg"
                        name="precio_por_kg"
                        label=""
                        placeholder={`Precio / ${coopConfig.acopioUnits()?.abreviacion} (${coopConfig.currency()?.symbol})`}
                        error={errors.precio_por_kg}
                        register={register}
                        step=".01"
                        value={getValues().precio_por_kg}
                      />
                    </div>
                  )}
                  {coopConfig.hasAcopioUnitsExtra() && !!precioKgValue && (
                    <div className="col-2 mt-2">
                      <p className="info-input" style={{ marginTop: 0, marginBottom: '3px', fontSize: 14 }}>
                        {/* Esta operación fue corregida por Nacho GM */}
                        {formatMoneyNumber(precioKgValue || 0)}
                        &nbsp;&nbsp;
                        {`${coopConfig.currency()?.symbol} / ${coopConfig.acopioUnits()?.abreviacion} `}
                      </p>
                    </div>
                  )}
                  {importeBruto && getValues().precio_por_kg && (
                    <div className="col-md-9">
                      <p className="importe-total">{`Importe bruto ${coopConfig.currency()?.symbol} ` + formatMoneyNumber(importeBruto)}</p>
                    </div>
                  )}
                </div>

                {/* Créditos */}
                {getIdCatCreditoPrecosecha() > 1 && pendientePagoCredito + anticipoPago > 0 && (
                  <>
                    <div className="row pl-2">
                      <p className="info-input">
                        {`Este productor tiene ${coopConfig.currency()?.symbol} ` +
                          formatMoneyNumber(pendientePagoCredito + anticipoPago) +
                          ' pendientes de pago de ' +
                          transformWord(etiquetaAnticipos, ['plural'])}
                      </p>
                    </div>

                    <div className="row">
                      <div className="col-md-9 mb-3">
                        <FormInputMaterialTest
                          id="recuperacion_credito"
                          name="recuperacion_credito"
                          label=""
                          placeholder={
                            'Recuperación ' + transformWord(etiquetaAnticipos, ['plural']) + ` (${coopConfig.currency()?.symbol})`
                          }
                          error={errors.recuperacion_credito}
                          register={register}
                          step=".01"
                          value={getValues().recuperacion_credito}
                        />
                      </div>
                      {montoPagar && montoPagar > 0 ? (
                        <div className="col-md-9">
                          <p className="importe-total">
                            {`Monto a pagar ${coopConfig.currency()?.symbol} ` + formatMoneyNumber(montoPagar)}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}

                {isValidPositiveNumber(precioKgValue) && (
                  <>
                    <div className="row pt-2">
                      <div className="col-md-9 mb-4">
                        <FormSelectMaterial
                          placeholder="Método de pago"
                          label="Método de pago"
                          options={metodosPago}
                          id={'id_metodo_pago'}
                          error={errors.id_metodo_pago}
                          register={register}
                          onChange={handlerSelectMetodoPago}
                          value={idMetodoPago || ''}
                          disabled={metodosPago.length === 1}
                        />
                        {errors?.id_metodo_pago && <div className="invalid-feedback">{errors?.id_metodo_pago.message}</div>}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-9 mb-4">
                        <FormInputMaterialTest
                          id="monto_pagado"
                          name="monto_pagado"
                          label=""
                          placeholder={`Monto pagado (${coopConfig.currency()?.symbol})`}
                          error={errors.monto_pagado}
                          register={register}
                          step=".01"
                          value={getValues().monto_pagado}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="row mb-2">
                  <div className="col-md-9">
                    <button className="btn btn-sirio btn-lg mt-3" type="submit" disabled={errorPesoBrutoVsTara}>
                      Continuar
                    </button>
                  </div>
                </div>
              </form>
            )}
            {showFirma && (
              <EntregasXProductorFirma
                metodosPago={metodosPago}
                data={dataForm}
                cuenta={cuenta}
                importeBruto={importeBruto}
                pesoNeto={pesoNeto}
                unidadesEntregas={unidadesEntregas}
                tiposCafe={tiposCafe}
                procesosCafe={procesosCafe}
                categorias={tipos}
              />
            )}
          </div>
          <div className="col-md-12 col-lg-5">
            <EntregasXProductorInfo uuid_cuenta={uuid_cuenta} id_cuenta={id_cuenta} />
          </div>
        </div>
        {/*
        <button onClick={() => {
          setShowForm(!showForm);
          setShowFirma(!showFirma);
        }} className="btn btn-sirio mt-3">Continuar</button>
      */}
      </CardContainer>
    </div>
  );
};

export default EntregasXProductor;
